import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { trackPageView } from '../utils/usageTracker';
import { useAppSelector } from '../redux';
import { selectContactFirstName } from '../features/AuthSlice/AuthSelectors';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { MainContentHeader } from '../components/MainContentHeader';
import { OverdueInvoicesOverview } from '../components/Invoices/OverdueInvoicesOverview';
import { InvoicesTable } from '../components/Invoices/InvoicesTable';
import { GenericLoadingState } from '../components/GenericLoadingState';
import { useInvoicesData } from '../hooks/useInvoicesData';
import { usePollInvoicePaid } from '../hooks/usePollInvoicePaid';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InvoicesPage = () => {
  var _overdueInvoicesData$;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paymentSuccess = searchParams.get('paymentSuccess') === 'true';
  const paidInvoiceIdParam = searchParams.get('paidInvoiceId');
  const paidInvoiceId = paymentSuccess && !!paidInvoiceIdParam ? Number(paidInvoiceIdParam) : null;
  const showInvoicePaidSuccessfully = paymentSuccess && !paidInvoiceId;
  const {
    loading: invoicesLoading,
    data: overdueInvoicesData
  } = useInvoicesData({
    pageLength: 100,
    filterStatuses: ['past_due']
  }, {
    nextFetchPolicy: 'cache-and-network'
  });
  const contactFirstName = useAppSelector(selectContactFirstName);
  useEffect(() => {
    trackPageView('invoices-overview');
  }, []);
  const {
    isPolling,
    onInvoicePaymentSuccess
  } = usePollInvoicePaid(paidInvoiceId);
  useEffect(() => {
    if (showInvoicePaidSuccessfully) {
      onInvoicePaymentSuccess(true);
    }
  }, [showInvoicePaidSuccessfully, onInvoicePaymentSuccess]);
  if (invoicesLoading && !overdueInvoicesData) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "INVOICES_OVERVIEW_LOAD",
      children: /*#__PURE__*/_jsx(MainContentLayout, {
        children: /*#__PURE__*/_jsx(GenericLoadingState, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "INVOICES_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsxs(MainContentLayout, {
      children: [isPolling && /*#__PURE__*/_jsx(LoadingOverlay, {
        label: unescapedText('invoices.processingPayment'),
        showLabel: true
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "700",
        children: [/*#__PURE__*/_jsx(OverdueInvoicesOverview, {
          contactFirstName: contactFirstName,
          overdueInvoices: (_overdueInvoicesData$ = overdueInvoicesData === null || overdueInvoicesData === void 0 ? void 0 : overdueInvoicesData.results) !== null && _overdueInvoicesData$ !== void 0 ? _overdueInvoicesData$ : []
        }), /*#__PURE__*/_jsx(MainContentHeader, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "invoices.title"
          })
        }), /*#__PURE__*/_jsx(InvoicesTable, {})]
      })]
    })
  });
};